import _, { isArray, isNumber } from 'lodash'

// Các hàm helper phục vụ trong màn chi tiết món ăn

export const hasLimitQuantity = (min, max) => min && max

// Lọc các topping ban đầu được chọn
export const filterFoodOptionTypes = (food_option_types = []) => {
  if (!food_option_types) return []

  return food_option_types.reduce((total, foodOptionType) => {
    const {
      required,
      min,
      max,
      food_options = [],
      auto_add = false,
      id: foodOptionTypeId,
      selected_default, // trường này sẽ quyết định topping type có được chọn default value hay không
    } = foodOptionType
    if (auto_add) {
      const newFoodOptions = food_options.map((item) => ({ ...item, quantity: item?.min || 1 }))
      const foodOptionTypeUpdate = {
        ...foodOptionType,
        food_options: newFoodOptions,
      }

      return total.concat(foodOptionTypeUpdate)
    }
    if (required && !isNumber(min) && !isNumber(max) && selected_default) {
      const foodOption = food_options[0] // Mặc định chọn ông đầu tiên
      // Trong trường hợp có set min => lấy theo min ngược lại thì sẽ là 1
      foodOption.quantity = foodOption.min || 1 // bổ sung thêm trường quantity để phục vụ cho việc tính toán

      const foodOptionTypeUpdate = {
        ...foodOptionType,
        food_options: [foodOption],
      }

      let totalArr = total.concat(foodOptionTypeUpdate)

      // Kiểm tra trong trường hợp có related_food_options hay không?
      if (foodOption?.related_food_options) {
        const relatedFoodOptionType = foodOption.related_food_options[0]
        const firstFoodOptionRelated = relatedFoodOptionType.food_options[0]
        firstFoodOptionRelated.quantity = 1 // Bổ sung thêm quantity để gửi lên BE

        const extraToppingTypes = {
          id: relatedFoodOptionType.food_option_type_id,
          name: relatedFoodOptionType.food_option_type_name,
          food_options: [firstFoodOptionRelated] || [],
          food_option_id_related: foodOption.id, // Mục đích là để đánh dấu là nó được sinh ra từ food option nào
          food_option_type_id_related: foodOptionTypeId, // Đánh dấu food option type mới này được tạo ra từ cái gì
          required: true,
          min: null,
          max: null,
          auto_add: false,
        }

        totalArr = totalArr.concat(extraToppingTypes)
      }

      return totalArr
    }

    return total
  }, [])
}

// Hàm xử lý dữ liệu food_option_types
export const getDefaultFoodOptionTypes = (food_option_types = []) => {
  if (!food_option_types) return []

  return food_option_types.reduce((total, foodOptionType) => {
    const {
      required,
      min,
      max,
      food_options = [],
      id: foodOptionTypeId,
      selected_default,
    } = foodOptionType

    let totalFoodOptionTypes = total.concat(foodOptionType)

    if (required && !isNumber(min) && !isNumber(max) && selected_default) {
      // Lấy ra phần tử đầu tiên trong mảng food options và kiểm tra xem có trường related_food_options hay không
      const firstFoodOption = food_options[0]
      // Nếu trong trường hợp có trường này thì sẽ chèn thêm food_option type mới vào ngay bên cạnh food option type hiện tại
      if (firstFoodOption?.related_food_options) {
        const relatedFoodOptionType = firstFoodOption.related_food_options[0]

        // Thực hiện nối thêm food option type mới vào sau food option type hiện tại này
        totalFoodOptionTypes = totalFoodOptionTypes.concat({
          id: relatedFoodOptionType.food_option_type_id,
          name: relatedFoodOptionType.food_option_type_name,
          food_options: relatedFoodOptionType.food_options || [],
          food_option_id_related: firstFoodOption.id, // Mục đích là để đánh dấu là nó được sinh ra từ food option nào
          food_option_type_id_related: foodOptionTypeId, // Đánh dấu food option type mới này được tạo ra từ cái gì
          required: true,
          selected_default: relatedFoodOptionType?.selected_default || false, // Nếu có set selected_default
          display_image: relatedFoodOptionType?.display_image || false,
          min: null,
          max: null,
          auto_add: false,
        })
      }
    }

    return totalFoodOptionTypes
  }, [])
}

export const convertDataDetail = (dataDetail, isBuffetItem) => {
  const {
    id,
    name,
    price,
    original_price,
    discount_amount,
    description,
    stock_quantity,
    max_quantity_per_order,
    images,
    food_option_types,
    vat_rate,
    food_type,
  } = dataDetail

  return {
    id,
    name,
    quantity: 1,
    original_price: original_price || 0, // bổ sung thêm giá gốc
    price: isBuffetItem ? 0 : price, // Trong trường hợp buffet thì chuyển giá món về 0
    is_buffet_item: isBuffetItem,
    discount_amount,
    description,
    stock_quantity,
    vat_rate,
    max_quantity_per_order,
    images: images || [],
    food_option_types: filterFoodOptionTypes(food_option_types),
    food_type,
  }
}

// Hàm xử lý check quantity khi người dùng bấm nút cộng topping
export const checkQuantityTopping = ({
  quantity,
  min,
  max,
  minFoodOptionType,
  maxFoodOptionType,
  totalQuantityFoodOptionType,
}) => {
  const hasLimitFoodOptionType = hasLimitQuantity(minFoodOptionType, maxFoodOptionType) // cha
  const hasLimitFoodOption = hasLimitQuantity(min, max) // con

  if (hasLimitFoodOptionType) {
    // 1. Trường hợp setting min/max cha
    if (hasLimitFoodOption) {
      // 1.1  Trường hợp setting min/max con
      if (quantity >= max) return true
      if (totalQuantityFoodOptionType >= maxFoodOptionType) return true
    } else {
      // 1.2  Không setting min/max con
      if (totalQuantityFoodOptionType >= maxFoodOptionType) return true
    }
  } else {
    // 2. Không setting min/max cha
    if (hasLimitFoodOption) {
      // 2.1 Trường hợp setting min/max con
      if (quantity >= max) return true
    }
  }

  return false
}

/**
 * Hàm tính tổng số lượng topping đã chọn theo food option type id
 * @param {Array} foodOptionTypes : mảng food option type được chọn
 * @param {Number} foodOptionTypeId : id food option type
 * @returns {Number}
 * Chú ý: Trong trường hợp một số food option type không được chọn (không tìm thấy trong mảng được chọn) sẽ trả về giá trị 0
 */
export const calcQuantityFoodOptionType = (foodOptionTypes = [], foodOptionTypeId) => {
  const foodOptionType = foodOptionTypes.find((item) => item.id === foodOptionTypeId)

  const foodOptions = foodOptionType?.food_options || []

  const total = foodOptions.reduce((total, current) => {
    return total + current.quantity
  }, 0)

  return total
}

/**
 * Hàm check lỗi liên quan đến food option type
1. Trường hợp require
    1. Trường hợp required và không setting min, max (radio type) nhưng chưa chọn (total quantity = 0)
    2. Trường hợp tổng quantity topping < min topping type
    3. Trường hợp tổng quantity topping  > max topping type
    4. Trường hợp chưa chọn topping nào => totalQuantityFoodOptionType = 0 (bằng với trường hợp 1.2)
2. Trường hợp not require
    1. Trường hợp tổng quantity topping  > max topping type
    2. Trường hợp tổng quantity topping < min topping type nhưng phải được chọn (total quantity > 0) thì mới tính
 */
export const checkErrorQuantityTopping = ({ required, min, max, totalQuantityFoodOptionType }) => {
  // 1
  if (required) {
    // 1.1
    if (!hasLimitQuantity(min, max) && totalQuantityFoodOptionType < 1) {
      return {
        isErrorRequired: true,
      }
    }

    // 1.2
    if (min && totalQuantityFoodOptionType < min) {
      return {
        isErrorMin: true,
      }
    }
    // 1.3
    if (max && totalQuantityFoodOptionType > max)
      return {
        isErrorMax: true,
      }
  } else {
    // 2
    // 2.1
    if (max && totalQuantityFoodOptionType > max)
      return {
        isErrorMax: true,
      }
    // 2.2
    if (min && totalQuantityFoodOptionType < min && totalQuantityFoodOptionType > 0)
      return {
        isErrorMin: true,
      }
  }

  return {}
}

/**
Verify lại toàn bộ topping xem có topping nào lỗi không trước khi add to cart
* Tại sao phải tính tổng dựa trên id của mảng ban đầu mà không phải là mảng được chọn?
  Giải thích: Vì có trường hợp topping bắt buộc nhưng là check box nên ban đầu sẽ không được chọn luôn.
  Nên sẽ không có trong danh sách topping được chọn

  Trong đó:
  1. foodOptionTypes: ban đầu
  2. foodOptionTypesSelected: được chọn
  Trường hợp lỗi => true ngược lại false

 */
export const verifyErrorTopping = ({ foodOptionTypes = [], foodOptionTypesSelected = [] }) => {
  return foodOptionTypes.some((item) => {
    const { min, max, required, id } = item

    const totalQuantityFoodOptionType = calcQuantityFoodOptionType(foodOptionTypesSelected, id)

    const error = checkErrorQuantityTopping({ required, min, max, totalQuantityFoodOptionType })

    if (error.isErrorMax || error.isErrorMin || error.isErrorRequired) return true

    return false
  })
}

/** Mục đich của việc tạo primary này để add to cart
 * Trong trường hợp user chọn trùng món nhưng chỉ tăng số lượng món
 * Nếu trong trường hợp trùng món nhưng mà topping khác => tạo thành một món mới
 *
 */
export const generatePrimaryKey = ({ foodId, foodOptionTypes = [], noteFood }) => {
  const listFoodOptions = foodOptionTypes.reduce((total, current) => {
    return total.concat(current.food_options)
  }, [])

  const sortedFoodOptions = _.orderBy(listFoodOptions, 'id')
    .map((i) => `${i.id}-${i?.quantity || 1}`)
    .join('-')

  return `${foodId}-${sortedFoodOptions}-${noteFood.trim() || ''}`
}

export const transformFoodOptionTypes = ({
  food_option_types = [],
  is_buffet_item,
  isPartnerSmaregi,
}) => {
  return food_option_types.map((item) => {
    return {
      ...item,
      foodOptions: item.food_options.map((foodOption) => {
        return {
          ...foodOption,
          price: is_buffet_item && !isPartnerSmaregi ? 0 : foodOption.price, // Trường hợp là buffet và partner không phải smaregi thì giá về 0. Vì Smaregi buffet topping có thể có giá
        }
      }), // bổ sung thêm trường này để phục vụ cho cart render ra
    }
  })
}

// Xử lý transform data để add to cart theo đúng format của cart
export const transformDataDetail = ({
  dataSelected,
  noteFood,
  primaryKey,
  restaurant_id,
  isPartnerSmaregi,
}) => {
  const {
    id,
    description,
    images,
    quantity,
    price,
    original_price,
    discount_amount,
    food_option_types,
    name,
    vat_rate,
    is_buffet_item,
    food_type,
    stock_quantity,
    max_quantity_per_order,
  } = dataSelected

  const newData = {
    id: id || -1,
    primaryKey,
    quantity,
    stock_quantity,
    max_quantity_per_order,
    price,
    original_price, // bổ sung thêm giá gốc
    discount_amount,
    name,
    description,
    image: isArray(images) && images.length > 0 ? images[0] : '',
    note: noteFood.trim(),
    foodOptionTypes: transformFoodOptionTypes({
      food_option_types,
      is_buffet_item,
      isPartnerSmaregi,
    }),
    vat_rate,
    is_buffet_item,
    food_type,
    restaurant_id, // mỗi lần add món ăn thì lưu thêm id của restaurant sau này dùng để group món ăn theo nhà hàng
  }

  return newData
}

// Hàm xử lý convert food_option_types của buffet giá về 0 hết
export const convertFoodOpitonTypesBuffet = (food_option_types = []) => {
  return food_option_types.map((foodOptionType) => {
    return {
      ...foodOptionType,
      food_options: foodOptionType.food_options.map((foodOption) => {
        return {
          ...foodOption,
          price: 0,
        }
      }),
    }
  })
}
